var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 75,
    viewBox: "0 0 54 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20H53.5V69C53.5 72.3137 50.8137 75 47.5 75H6.5C3.18629 75 0.5 72.3137 0.5 69V20Z",
    fill: "#BABFFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 24V19C44.5 9.05887 36.4411 1 26.5 1V1C16.5589 1 8.5 9.05887 8.5 19V24",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1094 49.4444V36",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6113 42.1111L27.1113 36L32.6113 42.1111",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 49.4453C37.5 55.5204 32.5751 60.4453 26.5 60.4453C20.4249 60.4453 15.5 55.5204 15.5 49.4453",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.0c9c9442a199ab6220d143a2784b605d.svg";
export { ForwardRef as ReactComponent };